import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Table, Tag, Timestamp } from '@dixa/lib-shared-habla';
import { typography } from '@dixa/lib-shared-tokens';
import { TableLoadingRow } from 'components/shared/tableLoadingRow';
import { mapPlatform } from '../../platforms';
import { ActionMenu } from './components/actionMenu/actionMenu';
import styles from './listPlatformsBody.module.scss';
const columnCount = 4;
export function ListPlatformsBody(props) {
    const { items, asyncStatus } = props;
    if (asyncStatus !== 'succeeded') {
        return _jsx(LoadingRow, Object.assign({}, props));
    }
    if (items.length === 0) {
        return (_jsx(Table.Tr, { children: _jsx(Table.Td, Object.assign({ colSpan: columnCount }, { children: "No push notification platforms found." })) }));
    }
    return (_jsx(_Fragment, { children: items.map((x) => (_jsxs(Table.Tr, { children: [_jsx(Table.Td, Object.assign({ className: styles.columnPlatformText }, { children: mapPlatform(x.platform) })), _jsx(Table.Td, { children: _jsx(PlatformStatus, { status: x.status }) }), _jsx(Table.Td, { children: x.updated_at ? _jsx(Timestamp, { relative: true, time: x.updated_at }) : '-' }), _jsx(Table.Td, Object.assign({ align: "right" }, { children: _jsx(ActionMenu, { platformId: x.id, onUpdate: props.showUpdateModal, onDelete: props.showDeleteModal }) }))] }, x.id))) }));
}
function LoadingRow(props) {
    const { asyncStatus, refreshItems } = props;
    if (asyncStatus === 'failed') {
        return (_jsx(Table.Tr, { children: _jsxs(Table.Td, Object.assign({ colSpan: columnCount }, { children: ["Something went wrong...", _jsx(Button, Object.assign({ variant: "tertiary", onClick: refreshItems }, { children: "Try again" }))] })) }));
    }
    return _jsx(TableLoadingRow, { colSpan: columnCount });
}
function PlatformStatus({ status, }) {
    switch (status) {
        case 'ACTIVE':
            return _jsx(Tag, Object.assign({ color: typography.color.success }, { children: "Active" }));
        case 'PROVISIONING':
            return _jsx(Tag, Object.assign({ color: typography.color.warning }, { children: "Provisioning" }));
        case 'DELETING':
            return _jsx(Tag, Object.assign({ color: typography.color.error }, { children: "Deleting" }));
        case 'ERROR':
            return _jsx(Tag, Object.assign({ color: typography.color.error }, { children: "Error" }));
    }
}
